import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { GaMetricsComponent } from './ga-metrics.component';
import { GaTableComponent } from './ga-table/ga-table.component';
import { GaMetricsService } from './ga-metrics.service';
import { DateRangeSelectorModule } from '../date-range-selector';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { VaGoalTableModule } from '@vendasta/uikit';
import { LoadingStateCardComponent } from '../loading-state-card/loading-state-card.component';
import { MatButtonModule } from '@angular/material/button';
import { MetricsCardComponent } from '../metrics/metrics-card/metrics-card.component';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';

@NgModule({
  declarations: [GaMetricsComponent, GaTableComponent],
  exports: [GaMetricsComponent],
  imports: [
    CommonModule,
    MatCardModule,
    TranslateModule,
    FormsModule,
    MatIconModule,
    MatSlideToggleModule,
    DateRangeSelectorModule,
    NgxChartsModule,
    VaGoalTableModule,
    LoadingStateCardComponent,
    MatButtonModule,
    MetricsCardComponent,
  ],
  providers: [GaMetricsService, provideHttpClient(withXhr(), withInterceptorsFromDi())],
})
export class GaMetricsModule {}
